export default __webpack_public_path__ + "static/media/Asset-27.2dd8b095.png";